/* ThermaKnee product template: variants, bundle cards, gallery, AJAX add to cart, sticky bar, dispatch cut-off. */
(() => {
  const formatMoney = (cents, format) => {
    const value = Number(cents) / 100;
    const fmt = (n, dec, thousands, decimal) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (d ? decimal + d : '');
    };
    return (format || '£{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
  };

  class TKProduct {
    constructor(root) {
      this.root = root;
      this.product = JSON.parse(root.querySelector('[data-tk-product-json]').textContent);
      this.config = JSON.parse(root.querySelector('[data-tk-config]').textContent);
      this.form = root.querySelector('[data-tk-form]');
      this.idInput = root.querySelector('[data-tk-variant-id]');
      this.atc = root.querySelector('[data-tk-atc]');
      this.sticky = root.querySelector('[data-tk-sticky]');
      this.variant = this.product.variants.find((v) => String(v.id) === this.idInput.value) || this.product.variants[0];

      root.querySelectorAll('[data-tk-option] input').forEach((input) =>
        input.addEventListener('change', () => this.onOptionChange(input)));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));

      this.initGallery();
      this.initSticky();
      this.initDispatch();
      this.render();
    }

    money(cents) { return formatMoney(cents, this.config.moneyFormat); }

    selectedOptions() {
      return this.product.options.map((_, i) => {
        const checked = this.root.querySelector(`[data-tk-option="${i}"] input:checked`);
        return checked ? checked.value : this.variant.options[i];
      });
    }

    findVariant(options) {
      return this.product.variants.find((v) => v.options.every((o, i) => o === options[i]));
    }

    onOptionChange(input) {
      const options = this.selectedOptions();
      let variant = this.findVariant(options);
      if (!variant) {
        // Keep the option the shopper just picked; fall back to the first available match.
        const idx = Number(input.closest('[data-tk-option]').dataset.tkOption);
        variant = this.product.variants.find((v) => v.options[idx] === input.value && v.available)
          || this.product.variants.find((v) => v.options[idx] === input.value);
        if (variant) {
          variant.options.forEach((val, i) => {
            const el = [...this.root.querySelectorAll(`[data-tk-option="${i}"] input`)].find((x) => x.value === val);
            if (el) el.checked = true;
          });
        }
      }
      if (!variant) return;
      this.variant = variant;
      this.render();
      this.goToMedia(variant.featured_media && variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    render() {
      const v = this.variant;
      const hasCompare = this.config.showCompare !== false && v.compare_at_price && v.compare_at_price > v.price;
      this.idInput.value = v.id;

      const q = (s) => this.root.querySelector(s);
      q('[data-tk-price-now]').textContent = this.money(v.price);
      const was = q('[data-tk-price-was]'); const save = q('[data-tk-price-save]');
      was.hidden = !hasCompare; save.hidden = !hasCompare;
      if (hasCompare) {
        was.textContent = this.money(v.compare_at_price);
        save.textContent = `You save ${this.money(v.compare_at_price - v.price).replace(/\.00$/, '')}`;
      }

      // Option labels + unavailable state for pills.
      this.product.options.forEach((name, i) => {
        const fs = this.root.querySelector(`[data-tk-option="${i}"]`);
        if (!fs) return;
        const label = fs.querySelector('[data-tk-option-value]');
        if (label) { const t = String(v.options[i]).replace(/-/g, ' '); label.textContent = t.charAt(0).toUpperCase() + t.slice(1).toLowerCase(); }
        fs.querySelectorAll('.tk-swatch').forEach((sw) => {
          const opts = [...v.options]; opts[i] = sw.querySelector('input').value;
          const match = this.findVariant(opts);
          sw.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      // Bundle cards: re-price against the currently chosen colour.
      const pi = this.config.packIndex;
      if (pi >= 0) {
        this.root.querySelectorAll('[data-tk-pack-card]').forEach((card) => {
          const opts = [...v.options]; opts[pi] = card.querySelector('input').value;
          const pv = this.findVariant(opts);
          if (!pv) return;
          const units = Number(card.dataset.units) || 1;
          card.querySelector('[data-tk-pack-price]').textContent = this.money(pv.price);
          const each = card.querySelector('[data-tk-pack-each]');
          if (each && this.config.showEach !== false) each.textContent = `${this.money(Math.round(pv.price / units))} each`;
          const pwas = card.querySelector('[data-tk-pack-was]'); const psave = card.querySelector('[data-tk-pack-save]');
          const pc = pv.compare_at_price && pv.compare_at_price > pv.price;
          pwas.hidden = !pc; psave.hidden = !pc;
          if (pc) {
            pwas.textContent = this.money(pv.compare_at_price);
            psave.textContent = `Save ${this.money(pv.compare_at_price - pv.price).replace(/\.00$/, '')}`;
          }
          card.classList.toggle('is-unavailable', !pv.available);
        });
      }

      // Stock + button state.
      const stock = q('[data-tk-stock]');
      stock.classList.remove('tk-stock--low', 'tk-stock--out');
      if (!v.available) { stock.textContent = 'Sold out. Back soon'; stock.classList.add('tk-stock--out'); }
      else if (this.config.lowStock[v.id]) { stock.textContent = 'Low stock: only a few left'; stock.classList.add('tk-stock--low'); }
      else stock.textContent = this.config.inStockText;

      this.atc.disabled = !v.available;
      q('[data-tk-atc-text]').textContent = v.available ? this.config.atcText : 'Sold out';

      if (this.sticky) {
        this.sticky.querySelector('[data-tk-sticky-price]').textContent = this.money(v.price);
        this.sticky.querySelector('[data-tk-sticky-variant]').textContent = v.public_title || v.title;
        const swas = this.sticky.querySelector('[data-tk-sticky-was]');
        swas.hidden = !hasCompare;
        if (hasCompare) swas.textContent = this.money(v.compare_at_price);
        this.sticky.querySelector('[data-tk-sticky-btn]').disabled = !v.available;
        const simg = this.sticky.querySelector('.tk-sticky__img');
        const vimg = v.featured_image && v.featured_image.src;
        if (simg && vimg) {
          const u = new URL(vimg, window.location.href);
          u.searchParams.set('width', '120');
          simg.removeAttribute('srcset');
          simg.src = u.toString();
        }
      }
    }

    /* ---------- Add to cart (uses the theme's cart drawer/notification when present) ---------- */
    async onSubmit(e) {
      e.preventDefault();
      if (this.atc.disabled) return;
      const errorBox = this.root.querySelector('[data-tk-error]');
      errorBox.classList.remove('is-visible');
      this.atc.classList.add('is-loading');
      this.atc.setAttribute('aria-busy', 'true');

      const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const formData = new FormData(this.form);
      const properties = {};
      formData.forEach((value, key) => {
        const m = key.match(/^properties\[(.+)\]$/);
        if (m) properties[m[1]] = value;
      });
      const items = [{
        id: Number(formData.get('id')),
        quantity: Number(formData.get('quantity')) || 1,
        ...(Object.keys(properties).length ? { properties } : {}),
      }];
      // Free gift add-ons (data-tk-gift-toggle): real £0 variants, added as extra line items in the same request.
      this.root.querySelectorAll('[data-tk-gift-toggle]:checked').forEach((toggle) => {
        const giftId = Number(toggle.dataset.tkGiftVariant);
        if (giftId) items.push({ id: giftId, quantity: 1 });
      });

      const payload = { items };
      if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
        payload.sections = cartUI.getSectionsToRender().map((s) => s.id);
        payload.sections_url = window.location.pathname;
        if (typeof cartUI.setActiveElement === 'function') cartUI.setActiveElement(document.activeElement);
      }

      try {
        const res = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to basket.');

        document.dispatchEvent(new CustomEvent('tk:added', { detail: data }));
        // Shrine/Dawn declare these as script-level globals (const), not window properties.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tk-product', productVariantId: this.variant.id, cartData: data });
        }
        if (cartUI && typeof cartUI.renderContents === 'function' && data.sections) {
          cartUI.classList.remove('is-empty');
          cartUI.renderContents(data);
        } else {
          window.location.href = this.config.cartUrl;
        }
      } catch (err) {
        errorBox.textContent = err.message;
        errorBox.classList.add('is-visible');
      } finally {
        this.atc.classList.remove('is-loading');
        this.atc.removeAttribute('aria-busy');
      }
    }

    /* ---------- Gallery ---------- */
    initGallery() {
      this.track = this.root.querySelector('[data-tk-track]');
      if (!this.track) return;
      this.slides = [...this.track.children];
      const dots = [...this.root.querySelectorAll('[data-tk-dot]')];
      const thumbs = [...this.root.querySelectorAll('[data-tk-thumb]')];
      const setActive = (i) => {
        this.activeSlide = i;
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
        thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
        // Keep the active thumb visible inside the scrolling thumb column (without scrolling the page).
        const t = thumbs[i]; const col = t && t.parentElement;
        if (col && col.scrollHeight > col.clientHeight) {
          if (t.offsetTop < col.scrollTop) col.scrollTop = t.offsetTop;
          else if (t.offsetTop + t.offsetHeight > col.scrollTop + col.clientHeight) col.scrollTop = t.offsetTop + t.offsetHeight - col.clientHeight;
        }
      };
      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          setActive(Math.round(this.track.scrollLeft / this.track.clientWidth));
          ticking = false;
        });
      }, { passive: true });
      dots.forEach((d) => d.addEventListener('click', () => this.goToSlide(Number(d.dataset.tkDot))));
      thumbs.forEach((t) => t.addEventListener('click', () => this.goToSlide(Number(t.dataset.tkThumb))));
      const prev = this.root.querySelector('[data-tk-prev]'); const next = this.root.querySelector('[data-tk-next]');
      if (prev) prev.addEventListener('click', () => this.goToSlide(Math.max(0, (this.activeSlide || 0) - 1)));
      if (next) next.addEventListener('click', () => this.goToSlide(Math.min(this.slides.length - 1, (this.activeSlide || 0) + 1)));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') next && next.click();
        if (e.key === 'ArrowLeft') prev && prev.click();
      });
      setActive(0);
    }

    goToSlide(i, instant = false) {
      if (!this.track) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant || reduce ? 'auto' : 'smooth' });
    }

    // Variant changes jump straight to the variant's image instead of sweeping through every slide in between.
    goToMedia(mediaId) {
      if (!mediaId || !this.slides) return;
      const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i >= 0) this.goToSlide(i, true);
    }

    /* ---------- Sticky ATC: visible once the main button has scrolled out of view ---------- */
    initSticky() {
      if (!this.sticky) return;
      const btn = this.sticky.querySelector('[data-tk-sticky-btn]');
      btn.addEventListener('click', () => {
        if (this.form.requestSubmit) this.form.requestSubmit(this.atc); else this.atc.click();
      });
      const show = (on) => {
        this.sticky.classList.toggle('is-visible', on);
        this.sticky.setAttribute('aria-hidden', String(!on));
        btn.tabIndex = on ? 0 : -1;
        // Keep the theme's scroll-to-top button clear of the bar on mobile.
        const topBtn = document.querySelector('.scroll-to-top-btn');
        if (topBtn) topBtn.style.marginBottom = on && window.innerWidth < 990 ? `${this.sticky.offsetHeight}px` : '';
      };
      const io = new IntersectionObserver(([entry]) => {
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      io.observe(this.atc);
    }

    /* ---------- Live UK dispatch cut-off (only rendered when enabled in the editor) ---------- */
    initDispatch() {
      const el = this.root.querySelector('[data-tk-dispatch]');
      if (!el) return;
      const cutoff = Number(el.dataset.cutoff) || 14;
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const update = () => {
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
        }).formatToParts(new Date()).map((p) => [p.type, p.value]));
        const dow = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
        const mins = Number(parts.hour) * 60 + Number(parts.minute);
        const weekday = dow >= 1 && dow <= 5;
        if (weekday && mins < cutoff * 60) {
          const left = cutoff * 60 - mins;
          el.innerHTML = `Order within <strong>${Math.floor(left / 60)}h ${left % 60}m</strong> for same-day dispatch`;
        } else {
          let next = (dow + 1) % 7;
          while (next === 0 || next === 6) next = (next + 1) % 7;
          el.innerHTML = `Order now for dispatch on <strong>${days[next]}</strong>`;
        }
      };
      update();
      setInterval(update, 60000);
    }
  }

  const init = (scope = document) => scope.querySelectorAll('[data-tk-product-root]').forEach((root) => {
    if (!root.tkProduct) root.tkProduct = new TKProduct(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
